import React from "react";
import { BtnUI } from "./Button";

const FilterButton = ({ onClick, children, inverted }) => {
  return (
    <BtnUI inverted={inverted} onClick={onClick}>
      {children}
    </BtnUI>
  );
};

export default FilterButton;
